import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { login, authorLogin } from "../../../redux/action/action";
import Axios from "axios";
import { Button } from "@material-ui/core";
import { url } from "../../../config/config";
import { useStyles } from "./SuccessMessage.css";

class SuccessMessage extends Component {
  state = {
    verifiedData: [],
  };

  componentDidMount() {
    this.getToken(this.props.match.params.successToken);
  }

  getToken = async (successToken) => {
    if (this.props.isAuth) {
      const response = await Axios.get(
        `${url}/api/email/verify/${successToken}`
      );
      if (response.data) {
        this.setState({
          verifiedData: response.data,
        });
      }

      if (response.data.error) {
        alert(response.data.error);
      } else {
        if (response.data.token) {
          this.props.login(response.data.token);
        }
      }
    }
    if (this.props.isAuthor) {
      const response2 = await Axios.get(
        `${url}/api/email/author/verify/${successToken}`
      );
      if (response2.data) {
        this.setState({
          verifiedData: response2.data,
        });
      }
      if (response2.data.error) {
        alert(response2.data.error);
      } else {
        if (response2.data.token) {
          this.props.authorLogin(response2.data.token);
        }
      }
    }
  };

  handleContinue = () => {
    this.props.history.push("/profile");
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.state.verifiedData.success && (
          <label>Your email is successfully verified</label>
        )}
        <Button onClick={this.handleContinue} className={classes.buttonStyle}>
          Continue
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    isAuthor: state.AuthorReducer.isAuthor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (userToken) => {
      dispatch(login(userToken));
    },
    authorLogin: (authorToken) => {
      dispatch(authorLogin(authorToken));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(SuccessMessage)));
